import * as React from 'react';
import type { SVGProps } from 'react';

const SvgTwitterBlack = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={19} height={17} fill="none" {...props}>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M18.605 2.385a7.457 7.457 0 0 1-2.192.616A3.905 3.905 0 0 0 18.091.836a7.518 7.518 0 0 1-2.425.95A3.764 3.764 0 0 0 12.88.55c-2.106 0-3.815 1.752-3.815 3.913 0 .307.033.605.098.892-3.172-.163-5.984-1.72-7.868-4.09-.34.6-.518 1.279-.516 1.97 0 1.357.673 2.555 1.697 3.256a3.748 3.748 0 0 1-1.729-.487v.047c0 1.898 1.316 3.48 3.063 3.838a3.644 3.644 0 0 1-1.005.138 3.66 3.66 0 0 1-.72-.07c.487 1.555 1.895 2.687 3.566 2.716A7.537 7.537 0 0 1 0 14.299a10.627 10.627 0 0 0 5.851 1.757c7.022 0 10.86-5.963 10.86-11.136 0-.17-.003-.34-.01-.507a7.834 7.834 0 0 0 1.904-2.027Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwitterBlack;
